import { declareParams } from '@farfetched/core';
import { zodContract } from '@farfetched/zod';
import { createAuthMutation } from '../auth-http-client';
import { countResponseSchema } from '../types';

export const createUnblockWalletMutation = () =>
	createAuthMutation({
		params: declareParams<number>(),
		request: {
			method: 'POST',
			url: (id) => `/account/wallet/unlock/${id}`,
			body: {},
		},
		response: {
			contract: zodContract(countResponseSchema),
		},
	});
